class PaginationInfinite extends HTMLElement {
    constructor() {
      super();
  
      this.gridContainer = document.querySelector(this.dataset.containerSelector);
  
      // Bail if there's no container
      if (!this.gridContainer) return;
  
      this.currentPage = parseInt(this.dataset.currentPage || 1);
      this.debouncedLoadNextPage = debounce(() => {
        this.loadNextPage();
      }, 100);
  
      // Create the intersection observer
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.debouncedLoadNextPage();
          }
        });
      });
  
      this.observer.observe(this);
    }
  
    loadNextPage() {
      // Bail if there's no next page URL and container
      if (this.currentPage >= parseInt(this.dataset.totalPages)) {
        this.observer.unobserve(this);
        return;
      }
  
      this.querySelector('.loading__spinner').classList.remove('hidden');
  
      const currentUrl = new URL(window.location.href);
      const currentPage = currentUrl.searchParams.get('page') || 1;
      const nextPage = parseInt(currentPage) + 1;
      this.currentPage = nextPage;
      currentUrl.searchParams.set('page', nextPage);
  
      // Fetch the next page
      fetch(currentUrl.href, { headers: { 'Content-Type': 'text/html' } })
        .then((response) => response.text())
        .then((html) => {
          const dom = new DOMParser().parseFromString(html, 'text/html');
          const newContainer = dom.querySelector(this.dataset.containerSelector);
  
          // Add cards with fade-in effect if we have a card selector
          if (this.dataset.cardSelector) {
            let count = 0;
            newContainer.querySelectorAll(this.dataset.cardSelector).forEach((card) => {
              card.classList.add('u-fade-in');
              setTimeout(() => {
                this.gridContainer.insertAdjacentHTML('beforeend', card.outerHTML);
              }, count * 25);
              count++;
            });
          }
          // Otherwise, just add the new container
          else {
            this.gridContainer.insertAdjacentHTML('beforeend', newContainer.innerHTML);
          }
  
          this.querySelector('.loading__spinner').classList.add('hidden');
  
          // Push state
          window.history.pushState({ path: currentUrl.href }, '', currentUrl.href);
        });
    }
  }
  
  customElements.define('pagination-infinite', PaginationInfinite);
  